import React, {useEffect} from 'react';
import {useQueryClient} from 'react-query';
import {useTranslation} from 'react-i18next';
import PropTypes from 'prop-types';
import moment from 'moment';
import es from 'antd/lib/locale/es_ES';
import en from 'antd/lib/locale/en_US';
import fr from 'antd/lib/locale/fr_FR';
import {ConfigProvider} from 'antd';
import {ReactComponent as NoData} from '@/assets/images/illustrations/no-data.svg';
import {useUser} from '@dofleini/security';
import {useInternationalization} from '@/contexts/InternationalizationContext';

const ANT_LOCALE = {
  es,
  en,
  fr,
};

const Empty = () => {
  const {t} = useTranslation('common');
  return (
    <div className={'text-center'}>
      <NoData className={'max-w-48 max-h-48'}/>
      <p>{t('emptyData')}</p>
    </div>
  );
};

const customizeRenderEmpty = () => <Empty/>;

const InternationalizationConfigProvider = ({children}) => {
  const {locale, updateLocale} = useInternationalization();
  const {i18n} = useTranslation();

  const {user} = useUser();
  const queryClient = useQueryClient();

  const userLanguage = user?.language;

  useEffect(() => {
    moment.locale(locale);
  }, [locale]);

  useEffect(() => {
    userLanguage && updateLocale(userLanguage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userLanguage]);

  useEffect(() => {
    i18n.changeLanguage(locale).then();
    queryClient.invalidateQueries();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locale]);

  const validateMessages = i18n.t('validateMessages', {returnObjects: true});

  return (
    <ConfigProvider
      locale={ANT_LOCALE[locale]}
      renderEmpty={customizeRenderEmpty}
      form={{validateMessages}}>
      {children}
    </ConfigProvider>
  );
};

InternationalizationConfigProvider.propTypes = {
  children: PropTypes.any
};


export {InternationalizationConfigProvider};
